export default function NotFound() {
  return (
    <div>
      <h1 className="text-3xl font-bold">Not Found</h1>
    </div>
  );
}
